export const DeleteEntitycontactByObjectid = `
    mutation deleteEntitycontactByObjectid ($objectid: Int!)  {
        deleteEntitycontactByObjectid (input: {objectid: $objectid}) {
            entitycontact {
                fullUid
                pocid
            }
        }
    }
`